// PRD.275 — Elia AI Assistant Drawer (Phase 1, UI only).
//
// Human-readable patient/visit context banner (FR-6). Props-driven; renders
// nothing when there is no patient context. The Change affordance is inert in
// Phase 1 and must not mutate real patient/encounter state.

import { ELIA_COLORS, ELIA_FONT } from './elia-theme';

export type EliaContextBannerProps = {
  patientName?: string;
  contextLabel?: string;
  onChange?: () => void;
};

export function EliaContextBanner({ patientName, contextLabel, onChange }: EliaContextBannerProps) {
  if (!patientName) return null;

  return (
    <div style={{ padding: '8px 12px 4px' }}>
      <div
        style={{
          background: ELIA_COLORS.pinkSoft,
          borderRadius: 14,
          padding: '8px 12px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 8,
          fontFamily: ELIA_FONT,
        }}
      >
        <div style={{ minWidth: 0 }}>
          <p
            style={{
              margin: 0,
              fontSize: 12,
              fontWeight: 600,
              color: ELIA_COLORS.text,
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
          >
            Discussing {patientName}
          </p>
          {contextLabel ? (
            <p
              style={{
                margin: 0,
                fontSize: 10,
                color: ELIA_COLORS.textMuted,
                whiteSpace: 'nowrap',
              }}
            >
              {contextLabel}
            </p>
          ) : null}
        </div>
        <button
          type="button"
          onClick={onChange}
          title="Change is a preview affordance — it does not switch real patient context yet"
          style={{
            minHeight: 24,
            display: 'inline-flex',
            alignItems: 'center',
            background: 'transparent',
            border: 'none',
            padding: '4px 0',
            cursor: 'pointer',
            color: ELIA_COLORS.pink,
            fontFamily: ELIA_FONT,
            fontSize: 12,
            fontWeight: 500,
            flexShrink: 0,
          }}
        >
          Change
        </button>
      </div>
    </div>
  );
}
